module.exports = __webpack_public_path__ + "img/EPBusinessBack3.d5b0b3a6.png";